module.exports = __webpack_public_path__ + "static/media/refresh-new.8d136329.svg";